import { Component, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'file-upload',
    templateUrl: "file-upload.component.html",
    styleUrls: ["file-upload.component.scss"]
})
export class FileUploadComponent {
    constructor(protected spinner: NgxSpinnerService, protected translate: TranslateService) { }

    public files: File[] = [];
    errorText: string;

    @ViewChild("fileUpload") fileInput!: HTMLInputElement;

    onFileSelected(event) {
        const files = event.target.files;
        if (files.length > 10) {
            this.errorText = "Max 10 filer kan laddas upp åt gången";
            return false;
        }

        let sumSize: number = 0;
        for(let ix = 0; ix < files.length; ix++)
            sumSize += files[ix].size;
        if (sumSize > 500_000_000) {
            this.errorText = "Max en halv GB av filer kan laddas upp åt gången";
            return false;
        }

        this.files = event.target.files;
        this.errorText = null;
    }

    public clear(): void {
        this.files = [];
        this.fileInput.value = '';
        this.errorText = null;
    }
}
